/**
 * Canonical site origin (+ basePath) used for SEO metadata, sitemap and robots.
 * Override at build time once the real domain is set:
 *   NEXT_PUBLIC_SITE_URL=https://eweb.by/studio npm run build
 */
export const SITE_URL = (process.env.NEXT_PUBLIC_SITE_URL ?? "https://eweb.by").replace(/\/$/, "");

/**
 * Studio identity. Wordmark + tagline shown in the nav, hero and footer.
 * Brand decided for the US market: "EWEB Studios" (domain eweb-studios.com, bought).
 * The wordmark renders "EWEB" as the mark + "Studios" as a lighter gold descriptor
 * (see components/Wordmark); this string is the plain form used in titles/JSON-LD.
 * Voice is first-person plural ("we"): a boutique studio, with Pavel (US) as the
 * client-facing contact. Domain switch + SEO activation happen at go-live.
 */
export const SITE_NAME = "EWEB Studios";
export const SITE_TAGLINE = "Custom Websites for US Brands";

/** One-line meta description reused across metadata + JSON-LD. */
export const SITE_DESCRIPTION =
  "We design and build custom, high-performance websites for US brands: bespoke, hand-coded, and engineered to outperform templates.";

/** Alt text for the link-preview card (public/og-v2.png). */
export const OG_IMAGE_ALT =
  "EWEB Studios: websites that outclass the templates. eweb-studios.com";
